var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-table",
                  {
                    ref: "table",
                    attrs: {
                      title: "일상점검 결과 목록",
                      merge: _vm.grid.merge,
                      columns: _vm.grid.columns,
                      data: _vm.grid.data,
                      gridHeight: _vm.grid.height,
                      selection: "multiple",
                      rowKey: "equipmentCd",
                      editable: !_vm.disabled,
                      columnSetting: false,
                      usePaging: false,
                    },
                    on: { headLinkClick: _vm.headLinkClick },
                    scopedSlots: _vm._u([
                      {
                        key: "customArea",
                        fn: function ({ props, col }) {
                          return [
                            col.name === "cycle1"
                              ? [
                                  props.row["cycle1"] === "Y"
                                    ? _c("span", [
                                        _vm._v(" " + _vm._s("●") + " "),
                                      ])
                                    : _vm._e(),
                                ]
                              : col.name === "cycle2"
                              ? [
                                  props.row["cycle2"] === "Y"
                                    ? _c("span", [
                                        _vm._v(" " + _vm._s("●") + " "),
                                      ])
                                    : _vm._e(),
                                ]
                              : col.name === "cycle3"
                              ? [
                                  props.row["cycle3"] === "Y"
                                    ? _c("span", [
                                        _vm._v(" " + _vm._s("●") + " "),
                                      ])
                                    : _vm._e(),
                                ]
                              : [
                                  props.row[col.name]
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.row[col.name]) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "prefixContent" },
                      [
                        !_vm.data.lineId && !_vm.data.checkDate
                          ? _c("font", { attrs: { color: "#C10015" } }, [
                              _vm._v(" ※ 라인과 점검년월을 선택하세요. "),
                            ])
                          : _vm._e(),
                        _c(
                          "font",
                          {
                            staticStyle: {
                              "font-size": "0.8em",
                              "font-weight": "300",
                            },
                          },
                          [
                            _c("q-icon", {
                              staticClass: "text-black",
                              attrs: { name: "radio_button_unchecked" },
                            }),
                            _vm._v(" : 정상    "),
                            _c("q-icon", {
                              staticClass: "text-black",
                              attrs: { name: "close" },
                            }),
                            _vm._v(" : 이상    "),
                            _c("q-icon", {
                              staticClass: "text-black",
                              attrs: { name: "circle" },
                            }),
                            _vm._v(" : 청소    V : 교환    "),
                            _c("q-icon", {
                              staticClass: "text-black",
                              attrs: { name: "check_box_outline_blank" },
                            }),
                            _vm._v(
                              " : 마모    △ : Oil 누유    ▲ : 점검필요    "
                            ),
                            _c("q-icon", {
                              staticClass: "text-black",
                              attrs: { name: "radio_button_checked" },
                            }),
                            _vm._v(" : 비가동    "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c(
            "c-dialog",
            {
              attrs: {
                param: _vm.popupOptions,
                returnData: { col1: _vm.data.dailyCheckId },
              },
            },
            [_vm._v(">")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }